(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('EditLicenceController', ['$scope', '$state', 'licence', 'templatePrefixes', 'LicenceService', 'Alert', 'Licence', 'SharedAgendaService', EditLicenceControllerFn]);

    /* main controller for licence edit */
    function EditLicenceControllerFn($scope, $state, licence, templatePrefixes, LicenceService, Alert, Licence, SharedAgendaService) {
        /* jshint validthis:true */
        var vm = this;

        // metronic ui init
        $scope.$on('$viewContentLoaded', function () {
            // initialize core components
            App.initAjax();
        });

        // save validation state to have access even when tabs change
        vm.formLicenceInvalid = false;

        // current licence
        vm.licence = {};
        // template prefixes
        vm.templatePrefixes = [];

        // do activation work
        activate();

        // set prefix
        vm.setPrefix = function (prefix) {
            vm.licence.templatePrefix = prefix;
        };

        /* save or update licence */
        vm.save = function () {
            // new object for save
            var licence = new Licence();
            licence.extend(vm.licence);

            // save or update
            if (licence && licence.id) {
                // update
                LicenceService.updateLicence(licence.id, licence).then(function (result) {
                    Alert.success(result.data);
                    // reload (just child)
                    $state.go($state.current, { 'licenceId': licence.id }, { reload: $state.current });
                    licence = null; // memory clean
                });
            } // if
            else {
                // save
                LicenceService.saveLicence(licence).then(function (result) {
                    Alert.success(result.caption + ' has been added successfully');
                    // go back to overview
                    $state.go('Home.Administration.Licences');
                    licence = null; // memory clean
                });
            } // else
        };

        /* cancel edit/new */
        vm.abort = function () {
            licence = null; // memory clean
            $state.go('Home.Administration.Licences');
        };

        /* load work */
        function activate() {
            // block shared agendas
            SharedAgendaService.block();

            // current licence (new or edit)
            if (licence === null || typeof licence === 'undefined' || licence.data === null || typeof licence.data === 'undefined') {
                // new licence
                vm.licence = new Licence();
                // breadcrumb label 
                vm.ncyLabel = 'new';
            } //if
            else {
                // licence to edit -> map to new Object
                vm.licence = new Licence();
                vm.licence.extend(licence.data);
                // breadcrumb label 
                vm.ncyLabel = 'edit';
            } // else

            // load template prefixes
            vm.templatePrefixes = templatePrefixes;

            // template prefix is required 
            if (typeof vm.licence.templatePrefix === 'undefined' || vm.licence.templatePrefix === null) {
                vm.licence.templatePrefix = vm.templatePrefixes[0];
            } //if

        } // activate

    }// function


})();
